// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"Footer_globalFooter__2m-HP","links":"Footer_links__34Y22","copyright":"Footer_copyright__WApAv"};